export default "__VITE_ASSET__Bi1FN_uI__"